'use client'

import { useLenis } from '@/providers/LenisProvider'
import { IoArrowUp } from 'react-icons/io5'
import { useState, useEffect } from 'react'

export const ScrollToTopButton: React.FC = () => {
  const { lenis } = useLenis()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when user scrolls down 300px
      if (window.scrollY > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    // Listen for scroll events
    window.addEventListener('scroll', toggleVisibility)

    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  const scrollToTop = () => {
    if (lenis) {
      lenis.scrollTo(0, { duration: 1.2 })
    } else {
      // Fallback for when Lenis isn't ready
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-20 right-2 md:right-6 md:bottom-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-text-black text-white shadow-lg transition-all duration-300 hover:bg-accent hover:text-black hover:scale-105 focus:outline-none ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
      }`}
      aria-label="Scroll to top"
    >
      <IoArrowUp className="h-6 w-6" />
    </button>
  )
}
